import { CALL_API } from "../api.middleware";
import {
  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILED,
  USER_LOGOUT,
  USER_PAN,
  USER_LOGIN_REFRESH,
  USER_LOGIN_REFRESH_SUCCESS,
  USER_LOGIN_REFRESH_FAILED,
  POSTER_OPEN,
  ENACH_UMR,
  ENACH_FOLIO,
  ENACH_BANK_ACC,
  ENACH_END_DATE,
  ENACH_START_DATE,
  ENACH_MAX_AMOUNT,
} from "../types/auth";

export const userLogin = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/login",
        body,
        method: "POST",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const passwordPolicy_JMF = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/PasswordPolicy_JMF",
        params,
        method: "GET",
        isPassword:true,
      },
    });
  } catch (error) {
    return { error };
  }
};


export const RefreshLogin = () => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/refresh_token",
        method: "GET",
        types: [
          USER_LOGIN_REFRESH,
          USER_LOGIN_REFRESH_SUCCESS,
          USER_LOGIN_REFRESH_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${"Session active time out. Please login again."}`);
  }
};

export const generateOtp = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/DistributorSignup",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const registration = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/DistributorAddUser",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const forgotUserId = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetForgotUsername",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
    // console.log(error);
  }
};

export const forgotPassword = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetForgotPassword",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const resetPassword = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ResetPassword",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const userLogout = () => {
  return {
    type: USER_LOGOUT,
  };
};

export const PosterOpen = (value) => {
  return {
    type: POSTER_OPEN,
    body: value,
  };
};

export const userPan = (Pan) => {
  return {
    type: USER_PAN,
    body: Pan,
  };
};

export const EnachUMR = (UMR) => {
  return {
    type: ENACH_UMR,
    body: UMR,
  };
};

export const EnachFolio = (folio) => {
  return {
    type: ENACH_FOLIO,
    body: folio,
  };
};

export const Enachbank = (Bank) => {
  return {
    type: ENACH_BANK_ACC,
    body: Bank,
  };
};

export const EnachEndDate = (date) => {
  return {
    type: ENACH_END_DATE,
    body: date,
  };
};
export const EnachStartDate = (date) => {
  return {
    type: ENACH_START_DATE,
    body: date,
  };
};
export const EnachMaxAmount = (amount) => {
  return {
    type: ENACH_MAX_AMOUNT,
    body: amount,
  };
};
// export const FundCodes = () => async dispatch =>{
//   try{
//     return await dispatch({

//     })
//   }catch (error) {
//     alert(`${error}`);
//   }
// }
export const validateForgotOtp = (body) => async (dispatch) => {
  try{
  return await dispatch({
    [CALL_API]: {
      url: "/validate-forgot-otp",
      body,
      method: "POST",
      showLoader: true,
    },
  });
} catch(e){
 return e
}
};
export const validateOTP = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/validate-otp",
        body,
        method: "POST",
        types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAILED],
        isLogin: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
}
export const SaveEmailMobile_Login = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SaveEmailMobile_Login",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
export const SendOtp_EmailorMOB = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SendOtp_EmailorMOB",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
export const Verify_EmailorMOB = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Verify_EmailorMOB",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
